export default function () {
   return {
       msisdn: sessionStorage.getItem('msisdn'),
       serviceId: sessionStorage.getItem('serviceId')
   }
}
